import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Typography, useTheme } from '@mui/material';

import { useT } from '@/hooks';

interface TradeSummaryProps {
  activeTab: 'buy' | 'sell';
  orderType: 'market' | 'limit' | 'more';
  totalCost: number;
  potReturn: number;
  potProfit: number;
}

export function TradeSummary({
  activeTab,
  orderType,
  totalCost,
  potReturn,
  potProfit,
}: TradeSummaryProps) {
  const theme = useTheme();
  const { t } = useT();

  return (
    <Box sx={{ mb: 2.5 }}>
      {activeTab === 'buy' ? (
        <>
          {orderType === 'limit' && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 1,
              }}
            >
              <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                {t('trade.totalCost', { defaultValue: 'Total Cost' })}
              </Typography>
              <Typography sx={{ fontSize: '0.875rem', fontWeight: 600, color: 'text.primary' }}>
                ${totalCost.toFixed(2)}
              </Typography>
            </Box>
          )}
          <Box
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}
          >
            <Typography
              sx={{
                fontSize: '0.875rem',
                color: 'text.secondary',
              }}
            >
              {t('trade.youllReceive', { defaultValue: "You'll receive" })}
            </Typography>
            <Typography
              sx={{
                fontSize: '0.875rem',
                fontWeight: 600,
                color: theme.palette.primary.main,
                textDecoration: 'underline',
                textDecorationStyle: 'dotted',
                textUnderlineOffset: 4,
              }}
            >
              ${potReturn.toFixed(2)}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography
                sx={{
                  fontSize: '0.875rem',
                  color: 'text.secondary',
                }}
              >
                {t('trade.estimatedProfit', { defaultValue: 'To Win' })}
              </Typography>
              <InfoOutlinedIcon sx={{ fontSize: '0.875rem', color: 'text.secondary' }} />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography
                sx={{
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  color: '#22c55e',
                }}
              >
                ${potProfit.toFixed(2)}
              </Typography>
            </Box>
          </Box>
        </>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography
              sx={{
                fontSize: '0.875rem',
                color: 'text.secondary',
              }}
            >
              {t('trade.youllReceive', { defaultValue: "You'll receive" })}
            </Typography>
            <InfoOutlinedIcon sx={{ fontSize: '0.875rem', color: 'text.secondary' }} />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography
              sx={{
                fontSize: '0.875rem',
                fontWeight: 600,
                color: '#22c55e',
              }}
            >
              ${potReturn.toFixed(2)}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}
